import React from 'react'
import { ProductSelection } from './styles'
import { StyledMenuItem } from '../../../../../../theme/Global'

const ProductSelect = ({
  currentProduct,
  products,
  handleChange
}) => {
  return currentProduct.id
    ? (
      <ProductSelection
        data-testid="product-select"
        value={currentProduct.id}
        name={currentProduct.name}
        onChange={handleChange}
      >
        {products.map((item) => (
          <StyledMenuItem
            data-testid={`product-select-${item.id}`}
            key={`${item.id}_${item.name}`}
            value={item.id}
          >
            {item.name}
          </StyledMenuItem>
        ))}
      </ProductSelection>
    )
    : null
}

export default ProductSelect
